import { useContext } from "react";
import { ItemViewModel } from "../../../../generated/data-contracts";
import { AvisModal } from "../../../shared/components/modal";
import { AvisContext } from "../../../shared/context";
import { CreationsNewPage } from "../creationViewNew/CreationsNewPage";
import { CreationType } from "../../../../models";

interface ICreationNewPickerProps {
  defaultCreationType: CreationType;
  createdNewCreationInfo: ItemViewModel | undefined;
  setCreatedNewCreationInfo: React.Dispatch<
    React.SetStateAction<ItemViewModel | undefined>
  >;
  onClose: () => void;
  onConfirm: () => void;
}
export function CreationNewPicker(props: Readonly<ICreationNewPickerProps>) {
  const {
    createdNewCreationInfo,
    defaultCreationType,
    setCreatedNewCreationInfo,
    onConfirm,
    onClose,
  } = props;
  const { res } = useContext(AvisContext);

  return (
    <AvisModal
      className="modal-form-with-scroll"
      isOpen={true}
      onConfirm={onConfirm}
      onClose={onClose}
      title={res("authors_UnidentifiedCreations_action_CreateNew")}
      confirmButtonText={res("button_Choose")}
      hideConfirm
      confirmButtonDisabled={!createdNewCreationInfo}
    >
      <CreationsNewPage
        defaultCreationType={defaultCreationType}
        creationTypeReadOnly={true}
        hideButtons={!!createdNewCreationInfo}
        onCreationCreated={(createdItem) => {
          setCreatedNewCreationInfo(createdItem);
          onConfirm();
        }}
      />
    </AvisModal>
  );
}
